module.exports = __webpack_public_path__ + "img/personalCenter_bg.4b971b08.png";